import { ethers } from "ethers";
import BigNumber from "Services/BigNumber";
import RoyaltiesStorageContract from "./RoyaltiesStorageContract";
import BaseRoyaltiesContractAdapter from "./core/BaseRoyaltiesContractAdapter";
import IRoyaltiesContractFunctions from "./core/IRoyaltiesContractFunctions";

export default class RoyaltiesStorageContractAdapter<T extends RoyaltiesStorageContract>
	extends BaseRoyaltiesContractAdapter<T>
	implements IRoyaltiesContractFunctions
{
	public constructor(contract: T) {
		super(contract, {
			estimateGasPrice: true,
			getRoyalties: true,
		});
	}

	public async estimateGasPrice(tx: ethers.PopulatedTransaction): Promise<BigNumber> {
		return this.contract.estimateGasPrice(tx);
	}
	public async getRoyalties(
		tokenAddress: string,
		tokenId: number,
		salePrice: BigNumber,
	): Promise<{ amounts: BigNumber[]; recipients: string[] }> {
		return this.contract.getRoyalties(tokenAddress, tokenId, salePrice);
	}
}
